<!-- Modal 调整部门  -->
<template>
  <el-dialog
    width="20%"
    :visible.sync="this.$store.state.Dialog_Adjust_Members"
    :show-close="false"
    :before-close="closeDrawer"
    destroy-on-close
    @open="opendialog"
  >
    <CardHeader name="调整成员部门" @closeDrawer="closeDrawer"></CardHeader>

    <div class="addRole">
      <div class="tree">
        <el-tree
          ref="tree"
          class="input_input"
          :data="organizationTree"
          :props="defaultProps"
          node-key="deptId"
          :check-strictly="true"
          :default-checked-keys="[5]"
          :expand-on-click-node="false"
          :check-on-click-node="true"
          @check="change"
          default-expand-all
          show-checkbox
        >
        </el-tree>
      </div>

      <el-button class="okbtn" type="primary" @click="onSubmit">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { authdeptlist } from "@/api/api";
import CardHeader from "../../../components/cardHeader/index.vue";
export default {
  name: "adjustMembers",
  props: ["chooseUser", "DEinfo"],
  components: { CardHeader },
  data() {
    return {
      form: { name: "" },
      organizationTree: [],
      changeTo: null,
      defaultProps: {
        children: "children",
        label: "deptName",
      },
    };
  },

  watch: {},

  methods: {
    opendialog() {
      console.log("打开了", this.$props.chooseUser, this.$props.DEinfo);
      this.getTree();
    },
    closeDrawer() {
      this.$store.commit("SET_Dialog_Adjust_Members", false);
    },
    // 获取组织树
    async getTree() {
      this.organizationTree = [];
      let params = {
        deptPId: this.$props.DEinfo.deptId,
      };
      let res = await authdeptlist(params);
      if (res.code == 200) {
        for (let i in res.data) {
          this.organizationTree.push(res.data[i]);
        }
        // this.$refs.tree.setCheckedKeys([this.$props.DEinfo.deptId]);
        console.log("测试");

        this.$refs.tree.setCheckedKeys([5]);
        console.log(this.$refs.tree.getCheckedKeys());
      }
    },
    // 节点选中状态发生变化时的回调
    change(data, e, l) {
      // this.$refs.tree.setCheckedKeys([data.deptId]);
      // this.changeTo = data;
      console.log(this.$refs.dtTree.getCheckedKeys());
    },
    // 点击提交
    onSubmit() {
      if (this.changeTo) {
        // let params = {
        //   targetDeptId: this.changeTo.deptId,
        //   oldDeptId: this.$props.DEinfo.deptId,
        //   users: this.$props.chooseUser,
        // };
        let params = {
          deptIds: this.changeTo.deptId,
          companyId: this.$props.DEinfo.companyId,
          userId: this.$props.chooseUser,
        };

        console.log(params);

        return;
        authusermobile(params).then((res) => {
          if (res.code == 200) {
            this.$store.commit("SET_Refresh_Organize");
            this.$store.commit("SET_Refresh_UserList");
            this.$store.commit("SET_Refresh_User_Msg");
            this.$store.commit("SET_Dialog_Change_Dept", this.changeTo);
            this.closeDrawer();
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "请选择要调整的部门",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.addRole {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
  .tree {
    width: 90%;
    height: 25rem;
    overflow-y: auto;
  }
  .okbtn {
    margin-top: 1rem;
  }
}
</style>